import { render, staticRenderFns } from "./ConsultTestimonials.vue?vue&type=template&id=0b11aea3&scoped=true&"
import script from "./ConsultTestimonials.vue?vue&type=script&lang=js&"
export * from "./ConsultTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./ConsultTestimonials.vue?vue&type=style&index=0&id=0b11aea3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b11aea3",
  null
  
)

export default component.exports